import { MockHttpResponse } from 'src/app/core/models';

export const submitPharmReorder = () => ({});

export const submitPharmReorderError = (): MockHttpResponse<any> => ({
  responseHttpStatus: 200,
  responseBody: {
    success: false,
    returnCode: 400,
    messages: [],
    errors: ['Pharm Order Error'],
    rowCount: 0,
    data: [],
  },
});
